import { render, staticRenderFns } from "./AddTagConfig.vue?vue&type=template&id=115362a2&scoped=true"
import script from "./AddTagConfig.vue?vue&type=script&lang=js"
export * from "./AddTagConfig.vue?vue&type=script&lang=js"
import style0 from "./AddTagConfig.vue?vue&type=style&index=0&id=115362a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115362a2",
  null
  
)

export default component.exports